import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

function initalState() {
  return {
    indexUI: 0,
    pageValidation: {
      0: true,
      1: false,
      2: false,
      3: true
    },
    filingStatus: '',
    filingStatusOptions: {
      age65: false,
      blind: false
    },
    adjustedGrossIncome: 0,
    charitableContributions: 0,
    medicalAndDental: 0,
    mortgageInterest: 0,
    variousTaxes: 0
  }
}

export default new Vuex.Store({
  state: {
    indexUI: 0,
    pageValidation: {
      0: true,
      1: false,
      2: false,
      3: true
    },
    filingStatus: '',
    filingStatusOptions: {
      age65: false,
      blind: false
    },
    adjustedGrossIncome: 0,
    charitableContributions: 0,
    medicalAndDental: 0,
    mortgageInterest: 0,
    variousTaxes: 0
  },
  mutations: {
    PREV_PAGE (state) {
      state.indexUI--
      document.body.scrollTop = 0
      document.documentElement.scrollTop = 0
    },
    NEXT_PAGE (state) {
      state.indexUI++
      document.body.scrollTop = 0
      document.documentElement.scrollTop = 0
    },
    SET_VALID (state, page) {
      state.pageValidation[page] = true
    },
    SET_FILING_STATUS (state, payload) {
      state.filingStatus = payload
    },
    SET_FILING_STATUS_OPTIONS (state, payload) {
      state.filingStatusOptions[payload.key] = !state.filingStatusOptions[payload.key]
    },
    UPDATE_STORE (state, payload) {
      state[payload.key] = payload.value
    },
    RESTART (state) {
      const s = initalState()
      Object.keys(s).forEach(key => {
        state[key] = s[key]
      })
    }
  },
  actions: {

  }
})
